import { done, error } from './common';

export function getTechnologySurvey(applicantId, callback) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.get(`/api/v2/applicants/${applicantId}/technology`)
      .then(resp => resp.data)
      .then(done(callback))
      .catch(error(callback))
    ;
  };
}

export function saveTechnologySurvey(applicantId, survey, callback) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.post(`/api/v2/applicants/${applicantId}/technology`,
      {
        body : survey
      })
      .then(resp => resp && resp.body && resp.body.data)
      .then(done(callback))
      .catch(error(callback))
    ;
  };
}

export function submitTechnologySurvey(applicantId, survey, callback) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.post(`/api/v2/applicants/${applicantId}/technology/submit`,
      {
        body : survey
      })
      .then(resp => resp && resp.body && resp.body.data)
      .then(done(callback))
      .catch(error(callback))
    ;
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/v2/applicants/technology.js